<template>
  <BreadCrumb PageTitle="Paramètres du compte" />
  <StatuSettings />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import StatuSettings from "../../components/Generals/AccountSettings/StatuSettings.vue";

export default defineComponent({
  name: "StatuSettingsPage",
  components: {
    BreadCrumb,
    StatuSettings,
  },
});
</script>